import React, { useState } from "react";
import {
  Col,
  Row,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Table,
  Badge,
} from "reactstrap";
import Header from "components/Header/Header";
import Footer_New from "components/Footer-New/Footer-New";
import LoginModal from "components/LoginModal/LoginModal";
import { useLoginModal } from "../contexts/LoginModalContext";
import swal from "sweetalert";
import axios from "axios";
import { API_DONOR_DARAH, API_TIMEOUT } from "utils";

function HistoriDonor() {
  const { isOpen, toggleModal } = useLoginModal();
  const [noHp, setNoHp] = useState("");
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [histori, setHistori] = useState([]);

  const validate = () => {
    const newErrors = {};
    if (!noHp.trim()) newErrors.noHp = "Nomor HP wajib diisi";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const formatDateDisplay = (value) => {
    if (!value) return "-";
    const str = String(value);
    if (str.includes("T")) return str.split("T")[0];
    return str;
  };

  const handleCari = async (e) => {
    e.preventDefault();
    if (!validate()) {
      swal("Info", "Mohon isi nomor HP pendonor", "info");
      return;
    }
    setIsLoading(true);
    try {
      const res = await axios.get(
        `${API_DONOR_DARAH}histori-donor?noHp=${encodeURIComponent(noHp)}`,
        { timeout: API_TIMEOUT }
      );
      if (res.data?.success) {
        const data = res.data.data || [];
        setHistori(data);
        if (data.length === 0) {
          swal(
            "Info",
            "Riwayat donor tidak ditemukan untuk nomor HP ini",
            "info"
          );
        }
      } else {
        swal("Error", res.data?.message || "Gagal mengambil data", "error");
      }
    } catch (error) {
      const msg =
        error.response?.data?.message ||
        error.message ||
        "Terjadi kesalahan saat mengambil data";
      swal("Error", msg, "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Header />
      <LoginModal isOpen={isOpen} toggle={toggleModal} />
      <div
        className="content"
        style={{
          margin: 20,
          background: "#ffffff",
          minHeight: "100vh",
          padding: "20px 0",
        }}
      >
        {/* Header Section */}
        <Row style={{ marginBottom: "30px" }}>
          <Col xs="12">
            <Card
              style={{
                background: "linear-gradient(135deg, #e63946 0%, #d62828 100%)",
                borderRadius: "20px",
                border: "none",
                boxShadow: "0 4px 25px rgba(230, 57, 70, 0.2)",
                padding: "35px",
                color: "#ffffff",
              }}
            >
              <h1
                style={{
                  fontSize: "2.2rem",
                  fontWeight: "300",
                  marginBottom: "10px",
                }}
              >
                🧾 Histori Donor
              </h1>
              <p style={{ fontSize: "1rem", opacity: 0.95, margin: 0 }}>
                Masukkan nomor HP untuk melihat riwayat donor (tabel
                darah_masuk)
              </p>
            </Card>
          </Col>
        </Row>

        {/* Pencarian + Tabel Histori dalam satu blok */}
        <Row>
          <Col xs="12">
            <Card
              style={{
                borderRadius: "18px",
                border: "none",
                boxShadow: "0 2px 20px rgba(0,0,0,0.08)",
              }}
            >
              <CardHeader
                style={{
                  background: "#ffffff",
                  borderBottom: "2px solid #f1f3f5",
                  padding: "25px 30px",
                }}
              >
                <CardTitle
                  tag="h4"
                  style={{
                    color: "#2d3436",
                    margin: 0,
                    fontWeight: "500",
                    fontSize: "1.3rem",
                  }}
                >
                  Cari & Lihat Histori Donor
                </CardTitle>
              </CardHeader>
              <CardBody style={{ padding: "20px 30px" }}>
                <Form onSubmit={handleCari} style={{ marginBottom: "20px" }}>
                  <Row>
                    <Col md="8">
                      <FormGroup>
                        <Label
                          for="noHp"
                          style={{ fontWeight: "500", color: "#2d3436" }}
                        >
                          Nomor HP Pendonor{" "}
                          <span style={{ color: "#e63946" }}>*</span>
                        </Label>
                        <Input
                          type="tel"
                          name="noHp"
                          id="noHp"
                          value={noHp}
                          onChange={(e) => {
                            setNoHp(e.target.value);
                            if (errors.noHp) {
                              setErrors((prev) => ({ ...prev, noHp: "" }));
                            }
                          }}
                          invalid={!!errors.noHp}
                          style={{
                            borderRadius: "10px",
                            border: errors.noHp
                              ? "2px solid #e63946"
                              : "1px solid #e9ecef",
                            padding: "12px 15px",
                          }}
                        />
                        {errors.noHp && (
                          <div
                            style={{
                              color: "#e63946",
                              fontSize: "0.875rem",
                              marginTop: "5px",
                            }}
                          >
                            {errors.noHp}
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                    <Col
                      md="4"
                      style={{
                        display: "flex",
                        alignItems: "flex-end",
                      }}
                    >
                      <Button
                        color="primary"
                        type="submit"
                        disabled={isLoading}
                        style={{
                          width: "100%",
                          padding: "12px 15px",
                          borderRadius: "10px",
                        }}
                      >
                        {isLoading ? "Memproses..." : "Lihat Histori"}
                      </Button>
                    </Col>
                  </Row>
                </Form>

                <Table responsive>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Tanggal</th>
                      <th>Donor</th>
                      <th>Gol. Darah</th>
                      <th>Jumlah Kantung</th>
                      <th>Tujuan</th>
                    </tr>
                  </thead>
                  <tbody>
                    {histori.length === 0 ? (
                      <tr>
                        <td colSpan="6" className="text-center">
                          Belum ada data histori
                        </td>
                      </tr>
                    ) : (
                      histori.map((item, index) => (
                        <tr key={item.id}>
                          <td>{index + 1}</td>
                          <td>{formatDateDisplay(item.tanggal)}</td>
                          <td>
                            {item.nama_donor || "-"}
                            <br />
                            <small className="text-muted">
                              {item.no_hp_donor || ""}
                            </small>
                          </td>
                          <td>
                            <Badge color="info">
                              {item.golonganDarah || "-"}
                            </Badge>
                          </td>
                          <td>{item.jumlah_kantung || "-"}</td>
                          <td>{item.tujuan || "-"}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
      <Footer_New />
    </>
  );
}

export default HistoriDonor;
